import React, { useEffect, useState } from 'react'
import { createUseStyles } from 'react-jss'
import obj2Arr from '../../utils/obj2Arr'
import ButtonLink from './atoms/ButtonLink'

const useStyles = createUseStyles(theme => ({
  maincontainer: {
    padding: '45px 0',
    '@media (max-width: 1200px)': {
      boxSizing: 'border-box',
      padding: '45px 35px',
    },
    '@media (max-width: 700px)': {
      boxSizing: 'border-box',
    },
  },
  container: {
    '& > div': {
      margin: '0 auto',
      width: '100%',
      maxWidth: '1220px',
      '@media (max-width: 1220px)': {
        width: 'auto',
        boxSizing: 'border-box',
        marginLeft: 15,
        marginRight: 15,
      },
    },
    '& + &': {
      marginTop: '40px',
    },
    '& *': {
      boxSizing: 'border-box',
    },
  },
  wrapper: {
    display: 'grid',
    justifyContent: 'space-evenly',
    gridGap: '40px',
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr !important',
    },
  },
  contenti: {
    padding: '17px 0',
  },
  image: {
    '& img': {
      maxWidth: '100%',
      height: 'auto',
      borderRadius: '20px',
      verticalAlign: 'bottom',
    },
  },
  title: {
    fontSize: '32px',
    lineHeight: 1.4,
    fontWeight: 700,
    fontFamily: 'TTRounds',
    textAlign: 'left',
    padding: '0',
    '& a': {
      color: 'inherit',
      textDecoration: 'none',
    },
  },
  details: {
    fontSize: '18px',
    lineHeight: 1.5,
    fontWeight: 300,
    marginTop: 16,
    fontFamily: 'AvenirNextLTPro',
    textAlign: 'left',
    '& ul': {
      '& li': { marginBottom: 7 },
      '& a': {
        color: theme.colors.main,
        textDecoration: 'underline',
        '&:hover': {
          color: theme.colors.main,
          textDecoration: 'underline',
          fontWeight: 'bold',
        },
      },
    },
    '& p': {
      margin: 0,
      '& + p': {
        marginTop: 15,
        '@media (max-width: 600px)': {
          marginTop: 15,
        },
      },
      '& a': {
        color: theme.colors.main,
        textDecoration: 'underline',
        '&:hover': {
          color: theme.colors.main,
          textDecoration: 'underline',
          fontWeight: 'bold',
        },
      },
    },
    '& a': {
      color: 'inherit',
      textDecoration: 'none',
    },
  },
  innerCTA: {
    textAlign: 'left',
    marginTop: '20px',
    '& a:nth-child(2)': {
      marginLeft: '15px',
    },
  },
}))

const ContentContainerBlock = props => {
  const [readMoreActive, setReadMoreActive] = useState(false)

  const {
    classes,
    isMobile,
    readMoreBtn,
    img,
    imgMobile,
    alt,
    boxstyle,
    boxorder,
    imagestyle,
    alignitems,
    title,
    details,
    titlefontsize,
    detailsfontsize,
    buttonText,
    buttonURL,
    buttonText2,
    buttonURL2,
    textcolor,
    minheight,
  } = props

  const containerImg = isMobile ? imgMobile : img

  return (
    <div
      className={classes.container}
      style={{
        padding: '0',
        ...(imagestyle === 'fullcontainerbg'
          ? {
              backgroundImage: `url('${containerImg}')`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
              borderRadius: '0',
              padding: '50px',
              overflow: 'hidden',
            }
          : {}),
      }}
    >
      <div
        className={classes.wrapper}
        style={{
          minHeight: minheight === '1' ? '400px' : 'auto',
          alignItems: alignitems,
          gridTemplateColumns:
            boxstyle === 'half' || boxstyle === 'halftext'
              ? '1fr 1fr'
              : boxstyle === 'fulltext'
              ? '1fr'
              : '2fr 1fr',
          ...(imagestyle === 'containerbg'
            ? {
                backgroundImage: `url('${containerImg}')`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                borderRadius: '20px',
                padding: '50px',
                overflow: 'hidden',
              }
            : {}),
        }}
      >
        {boxstyle !== 'fulltext' && imagestyle === 'normalimg' && (
          <div
            className={classes.image}
            style={{
              gridColumn: boxorder === 'image' ? 1 : 2,
            }}
          >
            <img src={containerImg} alt={alt} />
          </div>
        )}
        {boxstyle === 'fulltext' && imagestyle === 'normalimg' && (
          <div
            className={classes.image}
            style={{
              gridColumn: boxorder === 'image' ? 1 : 2,
            }}
          >
            <picture>
              <source media="(max-width:990px)" srcSet={imgMobile.replace(' ', '%20')} />
              <img src={img.replace(' ', '%20')} alt={alt} />
            </picture>
          </div>
        )}
        {boxstyle !== 'fulltext' && imagestyle === 'innerbg' && (
          <div
            className={classes.image}
            style={{
              backgroundImage: `url('${containerImg}')`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
              borderRadius: '20px',
              overflow: 'hidden',
              gridColumn: boxorder === 'image' ? 1 : 2,
            }}
          >
            <img src={containerImg} alt={alt} style={{ opacity: 0 }} />
          </div>
        )}
        <div
          className={classes.text}
          style={{
            gridColumn: boxorder === 'image' ? 2 : 1,
            gridRow: 1,
          }}
        >
          <div
            className={classes.title}
            style={{ fontSize: titlefontsize, color: textcolor }}
            dangerouslySetInnerHTML={{ __html: title }}
          />

          {details &&
            (readMoreBtn === '1' && !readMoreActive ? (
              <>
                <div style={{ overflow: 'hidden', maxHeight: '250px', position: 'relative' }}>
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundImage:
                        'linear-gradient(360deg, rgba(255,255,255,1) 5%, transparent 100%)',
                      backgroundRepeat: 'no-repeat',
                    }}
                  />
                  <div
                    className={classes.details}
                    style={{ fontSize: detailsfontsize, color: textcolor }}
                    dangerouslySetInnerHTML={{ __html: details }}
                  />
                </div>
                <a
                  href="#"
                  onClick={event => {
                    event.preventDefault()
                    setReadMoreActive(true)
                  }}
                  style={{ color: '#E10A0A', fontSize: '12px', fontWeight: 600 }}
                >
                  Read More &gt;
                </a>
              </>
            ) : (
              <div
                className={classes.details}
                style={{ fontSize: detailsfontsize, color: textcolor }}
                dangerouslySetInnerHTML={{ __html: details }}
              />
            ))}

          {(buttonText || buttonText2) && (
            <div className={classes.innerCTA}>
              {buttonText && <ButtonLink text={buttonText} url={buttonURL} primary />}
              {buttonText2 && <ButtonLink text={buttonText2} url={buttonURL2} />}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const ContentContainer = props => {
  const { blocks, backgroundcolor, nopadding, noPaddingTop } = props
  const [isMobile, setIsMobile] = useState(false)

  const classes = useStyles()
  const containerStyle = {
    ...(nopadding === '1' ? { padding: 0 } : {}),
    ...(noPaddingTop === '1' ? { paddingTop: 0 } : {}),
  }

  const blocksFiltered = obj2Arr(blocks)

  useEffect(() => {
    if (window.innerWidth < 900) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [])

  return (
    <div style={backgroundcolor ? { backgroundColor: backgroundcolor } : {}}>
      <div className={classes.maincontainer} style={containerStyle}>
        {blocksFiltered &&
          blocksFiltered.map(
            (block, i) => (
              <ContentContainerBlock key={i} classes={classes} isMobile={isMobile} {...block} />
            ),

            // {
            //   const {
            //     readMoreBtn,
            //     img,
            //     imgMobile,
            //     alt,
            //     boxstyle,
            //     boxorder,
            //     imagestyle,
            //     alignitems,
            //     title,
            //     details,
            //     titlefontsize,
            //     detailsfontsize,
            //     buttonText,
            //     buttonURL,
            //     buttonText2,
            //     buttonURL2,
            //     textcolor,
            //     minheight,
            //   } = block

            //   const containerImg = isMobile ? imgMobile : img

            //   return (
            //     <div
            //       className={classes.container}
            //       key={i}
            //       style={{
            //         padding: '0',
            //         ...(imagestyle === 'fullcontainerbg'
            //           ? {
            //               backgroundImage: `url('${containerImg}')`,
            //               backgroundSize: 'cover',
            //               backgroundRepeat: 'no-repeat',
            //               backgroundPosition: 'center center',
            //               borderRadius: '0',
            //               padding: '50px',
            //               overflow: 'hidden',
            //             }
            //           : {}),
            //       }}
            //     >
            //       <div
            //         className={classes.wrapper}
            //         style={{
            //           minHeight: minheight === '1' ? '400px' : 'auto',
            //           alignItems: alignitems,
            //           gridTemplateColumns:
            //             boxstyle === 'half' || boxstyle === 'halftext'
            //               ? '1fr 1fr'
            //               : boxstyle === 'fulltext'
            //               ? '1fr'
            //               : '2fr 1fr',
            //           direction: boxorder === 'image' ? 'ltr' : 'rtl',
            //           ...(imagestyle === 'containerbg'
            //             ? {
            //                 backgroundImage: `url('${containerImg}')`,
            //                 backgroundSize: 'cover',
            //                 backgroundRepeat: 'no-repeat',
            //                 backgroundPosition: 'center center',
            //                 borderRadius: '20px',
            //                 padding: '50px',
            //                 overflow: 'hidden',
            //               }
            //             : {}),
            //         }}
            //       >
            //         {boxstyle !== 'fulltext' && imagestyle === 'normalimg' && (
            //           <div className={classes.image}>
            //             <img src={containerImg} alt={alt} />
            //           </div>
            //         )}
            //         {boxstyle !== 'fulltext' && imagestyle === 'innerbg' && (
            //           <div
            //             className={classes.image}
            //             style={{
            //               backgroundImage: `url('${containerImg}')`,
            //               backgroundSize: 'cover',
            //               backgroundRepeat: 'no-repeat',
            //               backgroundPosition: 'center center',
            //               borderRadius: '20px',
            //               overflow: 'hidden',
            //             }}
            //           >
            //             <img src={containerImg} alt={alt} style={{ opacity: 0 }} />
            //           </div>
            //         )}
            //         <div className={classes.text}>
            //           <div
            //             className={classes.title}
            //             style={{ fontSize: titlefontsize, color: textcolor }}
            //             dangerouslySetInnerHTML={{ __html: title }}
            //           />

            //           {details &&
            //             (readMoreBtn === '1' ? (
            //               <>emre</>
            //             ) : (
            //               <div
            //                 className={classes.details}
            //                 style={{ fontSize: detailsfontsize, color: textcolor }}
            //                 dangerouslySetInnerHTML={{ __html: details }}
            //               />
            //             ))}

            //           {(buttonText || buttonText2) && (
            //             <div className={classes.innerCTA}>
            //               {buttonText && <ButtonLink text={buttonText} url={buttonURL} primary />}
            //               {buttonText2 && <ButtonLink text={buttonText2} url={buttonURL2} />}
            //             </div>
            //           )}
            //         </div>
            //       </div>
            //     </div>
            //   )
            // }
          )}
      </div>
    </div>
  )
}

export default ContentContainer
